<script setup>

import { defineProps, defineEmits} from "vue";
import CartaoDePedidoDeCompra from "./CartaoDePedidoDeCompra/CartaoDePedidoDeCompra.vue";
import JustificativaCartao from "./Justificativa/JustificativaCartao.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "pedidoDeCompra",
    "justificativa",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:justificativa"
]);

//==================================================================//
//===================== Altera Justificativa =======================//
//==================================================================//

const alteraJustificativa = (update) =>{

    emits('update:justificativa',update);

}

</script>

<template>

    <div class="c-conteudo">

        <CartaoDePedidoDeCompra
            :dado="pedidoDeCompra"
        ></CartaoDePedidoDeCompra>

        <JustificativaCartao
            :justificativa="justificativa"
            :controlesDesativoados="controlesDesativados"
            @update:justificativa="alteraJustificativa"
        ></JustificativaCartao>

    </div>

</template>

<style scoped>

.c-conteudo{
    display: grid;
    gap: 15px;
}

</style>